var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-footer"},[_c('svg-icon',{staticClass:"logo3",staticStyle:{"width":"150px","height":"72px"},attrs:{"icon-class":"logo3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }